var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { calculateAverageGrade, calculateGradeInner, calculateUserPlace, numericGradeToString, } from '../../service/grade/grade_utils';
export class CycleGrade {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    get currentGradeString() {
        if (this.numberOfAnswersGradeIsBasedOn === 0)
            return '';
        return numericGradeToString(this.currentGradeNumeric);
    }
    get averageGrade() {
        return numericGradeToString(this.averageGradeNumeric);
    }
    get userPlace() {
        return calculateUserPlace(this.averageRelativeUserKnowledge, this.relativeKnowledgeDistribution);
    }
    get score100() {
        return (6 - this.currentGradeNumeric) * 20;
    }
    get currentGradeNumeric() {
        return calculateGradeInner(this.pointsDividedByMaxpoints, this.averageRelativeUserKnowledge, this.relativeKnowledgeDistribution, this.instance);
    }
    get averageGradeNumeric() {
        return calculateAverageGrade(this.averageKnowledgePerQuestion, this.instance);
    }
    get instance() {
        return this.app.appInfo.instance;
    }
    get relativeKnowledgeDistribution() {
        return (this.app.topic && this.app.topic.json_options.relativeknowledge_distribution) || [];
    }
    get averageRelativeUserKnowledge() {
        return this.userKnowledgePerQuestion - this.averageKnowledgePerQuestion;
    }
    get deviationInKnowledge() {
        // scale [-1;1]
        return this.userKnowledgePerQuestion - this.averageKnowledgePerQuestion;
    }
    get userKnowledgePerQuestion() {
        const sumAverage = this.answersForGradeCalclulation.reduce((sumAverage, a) => sumAverage + a.points / a.maxPoints, 0);
        return sumAverage / this.answersForGradeCalclulation.length;
    }
    get averageKnowledgePerQuestion() {
        const sumAverage = this.answersForGradeCalclulation.reduce((sumAverage, a) => sumAverage + a.avg, 0);
        return sumAverage / this.answersForGradeCalclulation.length;
    }
    get pointsDividedByMaxpoints() {
        const [sumPoints, sumMaxPoints] = this.answersForGradeCalclulation.reduce(([sumPoints, sumMaxPoints], a) => [sumPoints + a.points, sumMaxPoints + a.maxPoints], [0, 0]);
        return sumPoints / sumMaxPoints;
    }
    get numberOfAnswersGradeIsBasedOn() {
        return this.answersForGradeCalclulation.length;
    }
    get answersForGradeCalclulation() {
        return this.app.cycle.cycleAnswers.completedAnswersInCycle;
    }
    get currentGradeColor() {
        if (this.deviationInKnowledge > 0)
            return '#029c19'; // green
        if (this.deviationInKnowledge > -0.1)
            return '#E17100'; // yellow
        return '#970000'; // red
    }
}
__decorate([
    computed
], CycleGrade.prototype, "currentGradeNumeric", null);
__decorate([
    computed
], CycleGrade.prototype, "averageGradeNumeric", null);
__decorate([
    computed
], CycleGrade.prototype, "userKnowledgePerQuestion", null);
__decorate([
    computed
], CycleGrade.prototype, "averageKnowledgePerQuestion", null);
__decorate([
    computed
], CycleGrade.prototype, "pointsDividedByMaxpoints", null);
__decorate([
    computed
], CycleGrade.prototype, "numberOfAnswersGradeIsBasedOn", null);
